module.exports = __webpack_public_path__ + "img/website.9eca0c01.png";